import { messages } from "../lib/messages";
import { FullScreenMessage } from "./FullScreenMessage";

/** OfflineScreen — обрыв связи при бутстрапе (docs/07-miniapp-ux.md §2.1). */
export function OfflineScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <FullScreenMessage
      testId="shop-offline"
      title={messages.network}
      action={
        <button
          type="button"
          onClick={onRetry}
          className="rounded-card bg-button px-6 py-3 font-medium text-button-text"
        >
          {messages.retry}
        </button>
      }
    />
  );
}
